import React, { Dispatch, ReactElement, useEffect, useState } from 'react'
import wind from "../assets/windLayer.png";
import { useMapLayersContext } from '../provider/MapLayers';
import { LocationMarkerPopup } from "../mainLayer/MainWindow";

type LayerWindPropsType = {
    name: string;
    color?: string;
}

const LayerWind = (props: LayerWindPropsType) => {
    const { selectLayerInMap, loadLayerInMap,setIsWindLoad } = useMapLayersContext();
    const [isSelectedWind, setIsSelectedWind] = useState<boolean>(true)
      
        useEffect(() => {
          if(loadLayerInMap === "wind" || loadLayerInMap === ""){
            setIsSelectedWind(true);
            }else if(loadLayerInMap !== "wind"){
                setIsSelectedWind(false);
            }
        }, [loadLayerInMap]);


          const WindIconClick = () => {
            if (!isSelectedWind) {
              selectLayerInMap("wind");
            } else {
              selectLayerInMap("windnot");
            }
            setIsWindLoad(false);
          };
        
          // useEffect(() => {
          //   if (isSelectedWind) {
          //     selectLayerInMap("wind");
          //   }else{
          //       console.log("----------windnot-----7----------")
          //   //  LocationMarkerPopup("windnot");
          //   }
          // }, [isSelectedWind]);

    return (
        <div className={`subItemWrapper`}   onClick={(e) => WindIconClick()} onTouchStart={(e) => WindIconClick()}>
                {props.color && (
                    <div className={`colorBox ${isSelectedWind ? 'selected' : ''}`} style={{backgroundColor: `${props.color}`}}></div>
                )}

                <div className={`colorBox ${isSelectedWind ? 'selected' : ''}`}>
                    <img src={wind} alt="" />
                </div>

                <span>{props.name}</span>
             
            </div>
    )
}

export default LayerWind;